export default __webpack_public_path__ + "static/David-db32d75e304c5916850df317252962db.png";